// @material-ui
import { makeStyles } from '@material-ui/styles'

export const structureInfoStyle = theme => ({
  root: {},

  rootInline: {
    padding: theme.spacing(2, 3, 3),
    borderLeft: `1px solid ${theme.variables.colors.divider}`,
  },

  contact: {
    padding: 0,
    margin: 0,
  },

  contactIcon: {
    color: theme.variables.colors.icon,
  },

  fields: {
    marginTop: theme.spacing(3),
  },

  user: {
    marginLeft: theme.spacing(2),
    overflow: 'hidden',
  },

  login: {
    fontWeight: theme.typography.fontWeightBold,
  },
  
  propHeaderField: {
    marginTop: theme.spacing(3)
  },
  
  propLinkField: {
    marginTop: theme.spacing(0.25),
    marginBottom: theme.spacing(0.25)
  },
  
  propStatusField: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2)
  }
})

export const useStructureInfoStyle = makeStyles(structureInfoStyle)
